import Container from '@mui/material/Container';
import React, { useEffect, useRef, useState, useContext } from 'react'
import axios from "axios"
import qz from "qz-tray";
import { Table, TableCell, TableContainer, TableHead, TableRow, TableBody, Paper, IconButton, Collapse, Typography, tableCellClasses, TextField } from '@mui/material';
import { Box, styled } from '@mui/system';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useReactToPrint } from 'react-to-print';
import { ComponentToPrint } from './ComponentToPrint'
import DeleteIcon from '@mui/icons-material/Delete';
import PrintIcon from '@mui/icons-material/Print';
import DeleteInvoiceDialog from './DeleteInvoiceDialog';
import LoaderDialog from './LoaderDialog';
import { AuthContext } from '../authContext/AuthContext'
import { getPriceNumber, getQtyNumber } from '../util.js'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#1776d1',
    color: 'white',
  }
}));

const Row = (props) => {
  const { row, handlePrint, isAdmin, handleClickOpenAlert } = props;
  const [open, setOpen] = useState(false);
  
  let originalSpit = 0;
  let actualSpit = 0;
  if (row.cart) {
    row.cart.forEach((c) => {
      const discountInPercentage = Number(c.discountInPercentage || 0);
      const discountMultiplier = (100 - discountInPercentage) / 100;
      originalSpit += getPriceNumber(c.quantity * c.sellingPriceInclTax);
      actualSpit += getPriceNumber(c.quantity * c.sellingPriceInclTax * discountMultiplier);
    });
  }
  const finalTotalSavings = row.totalSavings || (Math.round(originalSpit) - Math.round(actualSpit));

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' }, backgroundColor: row.delete && '#d32f2f' }}>
        <TableCell>
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell>{row.orderDate}</TableCell>
        <TableCell>{row._id}</TableCell>
        <TableCell align="right">{row.cgst && row.cgst.toFixed(2)}</TableCell>
        <TableCell align="right">{row.sgst && row.sgst.toFixed(2)}</TableCell>
        <TableCell align="right">{row.subtotal && row.subtotal.toFixed(2)}</TableCell>
        <TableCell align="right">{row.total && row.total.toFixed(2)}</TableCell>
        <TableCell align="right" sx={{ color: 'green', fontWeight: 'bold' }}>{finalTotalSavings ? finalTotalSavings.toFixed(2) : '0.00'}</TableCell>
        <TableCell align="right">{row.paymentMode}</TableCell>
        <TableCell align="right">{row.user.name}</TableCell>
        <TableCell align="right">{row.shopkey}</TableCell>
        <TableCell align="right">{row.deleteReason}</TableCell>
        <TableCell align="right">{row.draftName}</TableCell>
        <TableCell align="right">
          {(row.delete === false && row.draft === false) && <PrintIcon size="small" sx={{ cursor: 'pointer' }} onClick={() => handlePrint(row)} color="success"></PrintIcon>}
          {(isAdmin && row.delete === false) && <DeleteIcon size="small" onClick={() => {handleClickOpenAlert(row)}} color="error"></DeleteIcon>}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                ITEMS
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>CODE - NAME</TableCell>
                    <TableCell align="right">QTY</TableCell>
                    <TableCell align="right">RATE</TableCell>
                    <TableCell align="right">AMOUNT</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.cart.map((cartRow, index) => {
                    const cartRowDiscount = Number(cartRow.discountInPercentage || 0);
                    return (
                    <TableRow key={cartRow.itemKey + '_' + index}>
                      <TableCell component="th" scope="row">
                      {cartRow.itemKey} - {cartRow.itemName} {cartRowDiscount > 0 ? `(-${cartRowDiscount}%)` : ''}
                      </TableCell>
                      <TableCell align="right">{Number.parseFloat(cartRow.quantity).toFixed(3)}</TableCell>
                      <TableCell align="right">{ cartRow.sellingPriceInclTax }</TableCell>
                      <TableCell align="right">{ (cartRow.quantity * cartRow.sellingPriceInclTax * ((100 - cartRowDiscount) / 100)).toFixed(2) }</TableCell>
                    </TableRow>
                  )})}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const Invoice = () => {  
  const isMounted = useRef(true);
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [searchOrder, setSearchOrder] = useState("");
  const [searchItemName, setSearchItemName] = useState("");
  const [allShops, setAllShops] = useState([])
  const [orderShop, setOrderShop] = useState()
  const [shopName, setShopName] = useState("")
  const {user, shop} = useContext(AuthContext)
  let d = new Date();
  const [endDate, setEndDate] = React.useState(d.toISOString().split('T')[0])
  d.setDate(d.getDate() - 0);
  const [startDate, setStartDate] = React.useState(d.toISOString().split('T')[0])
  const loadOrders = async(startDate, endDate, user, shop) => {
    try {
      if (isMounted.current) setLoading(true)
      let d = new Date(endDate)
      d.setDate(d.getDate() + 1)
      const newEndDate = d.toISOString().split('T')[0]
	  let shopKeys = []
      user.allowedShops.forEach((s)=> {
        shopKeys.push(s.shopkey)
      })
      const res = user.isAdmin 
        ? await axios.post("/orders/find/date", {startDate, endDate: newEndDate, shopKeys}, {headers: {token:"Bearer " + user.token}}) 
        : await axios.post("/orders/find/date", {startDate, endDate: newEndDate}, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
      if (!isMounted.current) return;
      const data = [];
      res.data.map(item => data.push(item));
      setOrders(data)
      setLoading(false)
    } catch (err) {
      console.log(err)
      if (isMounted.current) setLoading(false)
    }
  };

  useEffect(() => {
    loadOrders(startDate, endDate, user, shop);
  },[startDate, endDate, user, shop]);

  useEffect(() => {
    const loadShops = async() => {
      try {
        const res = await axios.get("/shops", {headers: {token:"Bearer " + user.token}}) 
        if (!isMounted.current) return;
        const data = [];
        res.data.map(item => data.push(item));
        setAllShops(data)
      } catch (err) {
        console.log(err)
      }
    };
    loadShops()
  },[user]);

  const filteredOrdersWithId = orders.filter((order) => searchOrder === '' ? order : (String(order._id).includes(searchOrder)));
  const filteredOrders = filteredOrdersWithId.filter((order) => {
    if(searchItemName === '') {
      return true
    } else {
      const found = order.cart.find((c) => c.itemName.toLowerCase().includes(searchItemName.toLowerCase()))
      if(found) {
        return true
      }
      return false
    } 
  });

  const deleteOrder = async(invoiceDelete, reason) => {
    await axios.post("/orders/softdelete?id=" + invoiceDelete._id, {reason}, {headers: {token:"Bearer " + user.token}})
    await handleTransfer()
    handleCloseAlert();
    loadOrders(startDate, endDate, user, shop);
  }
  const handleTransfer = async() => {
    let updatedCart = invoiceDelete.cart.map(c => {return {itemKey: c.itemKey, itemName: c.itemName, from: "C", to: invoiceDelete.shopkey, qty: c.quantity, type: "Sales Return", transactionDate: new Date(), shopkey: shop.shopkey, discountInPercentage: c.discountInPercentage, isTokenRequired: c.isTokenRequired}})
    try {
      await axios.post("/transactions", updatedCart, {headers: {token:"Bearer " + user.token}})
    } catch (err) {
      console.log(err)
    }
  };
  const [cart, setCart] = useState([]);
  const [invoiceId, setInvoiceId] = useState()
  const [pytMode, setPytMode] = useState()
  const [subtotal, setSubtotal] = useState()
  const [total, setTotal] = useState(0)
  const [orderDate, setOrderDate] = useState()
  const [orderTime, setOrderTime] = useState()
  const [qty, setQty] = useState();
  const [tax, setTax] = useState();
  const [gstTotal, setGstTotal] = useState();
  const [waiter, setWaiter] = useState();
  const [totalRoundOff, setTotalRoundOff] = useState(0);
  const [totalSavings, setTotalSavings] = useState(0);
  const componentRef= useRef();
  const handleReactToPrint = useReactToPrint({
    content: () => componentRef.current
  })

  const handleThermalPrint = async (printPayload) => {
    try {
      const response = await axios.post("/print/thermal", printPayload, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}});
      
      if (response.data && response.data.base64Data) {
        if (!qz.websocket.isActive()) {
          qz.security.setSignatureAlgorithm("SHA512");
          qz.security.setCertificatePromise(function(resolve, reject) {
            axios.get("/print/certificate", {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
              .then(res => resolve(res.data))
              .catch(reject);
          });
          qz.security.setSignaturePromise(function(toSign) {
            return function(resolve, reject) {
              axios.post("/print/sign", { request: toSign }, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
                .then(res => resolve(res.data))
                .catch(reject);
            };
          });
          await qz.websocket.connect();
        }
        const printerName = response.data.printerName || "EPSON";
        const config = qz.configs.create(printerName);
        const printData = [{
          type: 'raw',
          format: 'base64',
          data: response.data.base64Data
        }];
        await qz.print(config, printData);
      }
    } catch (err) {
      console.error("Thermal Print Error:", err);
      alert("Thermal printing failed. Ensure QZ Tray is running and printer is connected. Falling back to browser print.");
      setInvoiceId(printPayload.invoiceId);
    }
  };

  const handlePrint = async (selectedRow) => {
    setCart(selectedRow.cart);
    let originalSpit = 0;
    let actualSpit = 0;
    const mappedCart = selectedRow.cart.map((c) => {
      const discountInPercentage = Number(c.discountInPercentage || 0);
      const isTokenRequired = Boolean(c.isTokenRequired || false);
      const discountMultiplier = (100 - discountInPercentage) / 100;
      originalSpit += getPriceNumber(c.quantity * c.sellingPriceInclTax);
      actualSpit += getPriceNumber(c.quantity * c.sellingPriceInclTax * discountMultiplier);
      return { ...c, discountInPercentage, isTokenRequired };
    });
    const calculatedTotalSavings = Math.round(originalSpit) - Math.round(actualSpit);
    const finalTotalSavings = selectedRow.totalSavings || calculatedTotalSavings;

    setCart(mappedCart);
    setSubtotal(parseFloat(selectedRow.subtotal).toFixed(2))
    setTotal(parseFloat(selectedRow.total).toFixed(2))
    setTotalRoundOff(parseFloat(selectedRow.totalRoundOff).toFixed(2));
    setTotalSavings(finalTotalSavings);
    setOrderDate(selectedRow.orderDate)
    setOrderTime(selectedRow.createdAt)
    setPytMode(selectedRow.paymentMode)
    const targetShop = allShops.find((shop) => shop.shopkey === selectedRow.shopkey);
    setOrderShop(targetShop)
    const sName = (selectedRow.shopkey === "BK" || selectedRow.shopkey === "CBK") ? "SRI KUMARAN SWEETS AND BAKERY"  : (selectedRow.shopkey === "SKR") ? "SRI KUMARAN RUCHI" : "SRI KUMARAN SWEETS";
    setShopName(sName)
    const groupByGST = mappedCart.reduce((group, item) => {
      const gst = item.cgst + item.sgst
      group[gst] = group[gst] ?? [];
      group[gst].push(item);
      return group;
    }, {});
    let tax = [];
    let qtyCount = 0;
    let gstall = 0;
    for (const [key, value] of Object.entries(groupByGST)) {
      let valueTotal = 0;
      let cgstValueTotal = 0
      let sgstValueTotal = 0
      let qc = 0;
      value.forEach((c)=> {
        qc += getQtyNumber(c.quantity);
        const discountMultiplier = (100 - (c.discountInPercentage || 0)) / 100;
        const val = getPriceNumber(c.sellingPriceExclTax * c.quantity * discountMultiplier);
        valueTotal += val;
        cgstValueTotal += getPriceNumber((val * c.cgst)/100)
        sgstValueTotal += getPriceNumber((val * c.sgst)/100)
      });
      qtyCount += qc;
      cgstValueTotal = (Math.trunc(cgstValueTotal*100)/100).toFixed(2)
      sgstValueTotal = (Math.trunc(sgstValueTotal*100)/100).toFixed(2)
      valueTotal = (Math.trunc(valueTotal*100)/100).toFixed(2)
      gstall = gstall +  Number.parseFloat(cgstValueTotal) +  Number.parseFloat(sgstValueTotal)
      tax.push({"gst": key, "cgst": Number.parseInt(key)/2, "cgstvalue": cgstValueTotal, "sgst": Number.parseInt(key)/2, "sgstvalue": sgstValueTotal, "valueTotal": valueTotal})
    }
    setGstTotal((Math.trunc(gstall*100)/100).toFixed(2))
    setTax(tax)
    setQty((Math.trunc(qtyCount*100)/100).toFixed(2));
    setWaiter(selectedRow.user.name)

    const shopSetting = shop?.settings?.find(s => !s.mainCategory && !s.subCategory && !s.subSubCategory && !s.itemKey);
    const useNativePrint = shopSetting?.settings?.useNativeBrowserPrint ?? true;

    if (useNativePrint) {
      setInvoiceId(selectedRow._id)
    } else {
      handleThermalPrint({
        invoiceId: selectedRow._id, 
        cart: mappedCart, subtotal: parseFloat(selectedRow.subtotal).toFixed(2), 
        sgst: selectedRow.sgst, cgst: selectedRow.cgst, total: parseFloat(selectedRow.total).toFixed(2), totalRoundOff: parseFloat(selectedRow.totalRoundOff).toFixed(2), 
        orderDate: selectedRow.orderDate, qty: (Math.trunc(qtyCount*100)/100).toFixed(2), tax, gstTotal: (Math.trunc(gstall*100)/100).toFixed(2), totalSavings: finalTotalSavings,
        waiter: selectedRow.user.name, shop: targetShop, shopName: sName,
        pytMode: selectedRow.paymentMode, orderTime: selectedRow.createdAt
      });
    }
  };

  useEffect(() => {
    if(invoiceId) {
      handleReactToPrint()
      setInvoiceId(undefined)
    }
  }, [invoiceId, handleReactToPrint]);

  const [openAlert, setOpenAlert] = useState(false);
  const [invoiceDelete, setInvoiceDelete] = useState();
  const handleCloseAlert = () => {
    setOpenAlert(false);
    setInvoiceDelete();
  };
  const handleClickOpenAlert = (invoice) => {
    setOpenAlert(true);
    setInvoiceDelete(invoice);
  };
  return (
    <div>
       <Container maxWidth="false" disableGutters sx={{height: "92vh", width: "100vw"}}>
        <LoaderDialog open={loading} title="Loading Invoices ..."/>
        <Box sx={{paddingTop: .5, paddingLeft: .5, paddingRight: .5}}>
          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
          <TableContainer sx={{ maxHeight: "92vh", minHeight: "92vh" }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell colSpan="3"><TextField label="Start date" type="date" defaultValue={startDate} InputLabelProps={{ shrink: true, }} variant="standard" SelectProps={{native: true}} fullWidth onChange={(event)=> setStartDate(event.target.value)}/></TableCell>
                <TableCell colSpan="3"><TextField label="End date" type="date" defaultValue={endDate} InputLabelProps={{ shrink: true, }} variant="standard" SelectProps={{native: true}} fullWidth onChange={(event)=> setEndDate(event.target.value)}/></TableCell>
                <TableCell colSpan="3"><TextField label="Search Order" variant="standard" fullWidth  size="small" value={searchOrder} onChange={(event)=> setSearchOrder(event.target.value)}/></TableCell>
                <TableCell colSpan="3"><TextField label="Search Item Name" variant="standard" fullWidth  size="small" value={searchItemName} onChange={(event)=> setSearchItemName(event.target.value)}/></TableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell />
                <StyledTableCell>DATE</StyledTableCell>
                <StyledTableCell>INVOICE #</StyledTableCell>
                <StyledTableCell align="right">CGST</StyledTableCell>
                <StyledTableCell align="right">SGST</StyledTableCell>
                <StyledTableCell align="right">SUB TOTAL</StyledTableCell>
                <StyledTableCell align="right">TOTAL</StyledTableCell>
                <StyledTableCell align="right">SAVINGS</StyledTableCell>
                <StyledTableCell align="right">MODE</StyledTableCell>
                <StyledTableCell align="right">SALES PERSON</StyledTableCell>
                <StyledTableCell align="right">SHOP</StyledTableCell>
                <StyledTableCell align="right">DELETE REASON</StyledTableCell>
                <StyledTableCell align="right">DRAFT NAME</StyledTableCell>
                <StyledTableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredOrders.map((order) => (
                <Row key={order._id} row={order} handlePrint={handlePrint} isAdmin={user.isAdmin} handleClickOpenAlert={handleClickOpenAlert}/>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        </Paper>
        </Box>
        <div style={{display: 'none'}}>
          <ComponentToPrint ref={componentRef} invoiceId={invoiceId} cart={cart} subtotal={subtotal} total={total} orderDate={orderDate} qty={qty} tax={tax} gstTotal={gstTotal} waiter={waiter} totalRoundOff={totalRoundOff} shop={orderShop} shopName={shopName} pytMode={pytMode} orderTime={orderTime} totalSavings={totalSavings}/>
        </div>
      </Container>
      <DeleteInvoiceDialog open={openAlert} handleClose={handleCloseAlert} invoiceDelete={invoiceDelete} handleDeleteInvoice={deleteOrder}/>
    </div>
  )
}

export default Invoice
